<template>
  <v-row no-gutters class="login-page pa-4">
    <v-col>
      <v-card elevation="0" :color="$vuetify.breakpoint.mdAndUp ? 'rgba(0, 0, 0, 0)' : 'white'" class="mx-auto rounded-xl" max-width="500">
        <v-card-title>
          <v-row no-gutters style="text-align: -webkit-center">
            <v-col align-self="center">
              <v-img :width="$vuetify.breakpoint.mdAndUp ? 160 : 120" :max-height="$vuetify.breakpoint.mdAndUp ? 120 : 115" contain src="@/assets/image/Logo e-Verification-01.png"></v-img>
            </v-col>
            <v-col v-if="ref_code_client != null && ref_code_client.client_logo_url != ''" align-self="center">
              <v-img :width="$vuetify.breakpoint.mdAndUp ? 160 : 120" :max-height="$vuetify.breakpoint.mdAndUp ? 120 : 115" contain :src="ref_code_client.client_logo_url"></v-img>
            </v-col>
          </v-row>
        </v-card-title>
        <v-spacer></v-spacer>
        <form ref="form" @submit.prevent="loginByClientRefCode()">
          <!-- <v-card-text class="loginform pa-6 px-sm-8"> -->
          <v-card-text class="loginform">
            <div class="text-button-color pb-3">เข้าสู่ระบบ</div>
            <v-text-field
              v-model="username"
              rounded
              placeholder="ระบุ Username หรือ One Email"
              outlined
              dense
              hide-details="auto"
              required
            ></v-text-field>
            <!-- <p class="pt-6 mb-2">รหัสผ่าน</p> -->
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              placeholder="ระบุรหัสผ่าน"
              rounded
              outlined
              dense
              hide-details="auto"
              required
              class="pt-6 mb-2"
            ></v-text-field>
            <v-row no-gutters>
              <!-- <v-col cols="6" align-self="center"
                ><v-checkbox
                  v-model="checkbox"
                  class="ma-0 pa-0"
                  label="จดจำฉันไว้ในระบบ"
                  hide-details
                ></v-checkbox
              ></v-col> -->
              <v-col cols="12" align-self="center" style="text-align: right;"
                ><v-btn
                  text
                  color="default_primary"
                  :href="redirect_forget_password"
                  target="_blank"
                  class="pa-0"
                >
                  ลืมรหัสผ่าน
                </v-btn></v-col
              >
            </v-row>
            <v-row no-gutters class="pt-4">
              <v-col cols="12" class="pb-3">
                <v-btn
                  block
                  :loading="loading"
                  type="submit"
                  color="default_primary"
                  dark
                  rounded
                  elevation="0"
                  class="submitbutton"
                  :disabled="username == '' || password == '' || loading"
                >
                  <span class="text-button-login">ลงชื่อเข้าใช้</span></v-btn
                >
              </v-col>
              <v-col cols="12" class="pb-3">
                <div class="text-button-login text-center pb-4">
                  <v-row no-gutters>
                    <v-col align-self="center">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="auto" class="px-4" align-self="center">
                      หรือ
                    </v-col>
                    <v-col align-self="center">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </div>
                <v-btn
                  block
                  rounded
                  :href="redirect_register"
                  outlined
                  color="default_primary"
                  dark
                  class="submitbutton"
                >
                  <span class="text-button-login">ลงทะเบียน</span></v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LoginPage',
  metaInfo: {
    title: 'เข้าสู่ระบบ'
  },
  data () {
    return {
      username: '',
      password: '',
      // username: 'testetranscript', // super admin
      // password: 'm12345678',
      // username: 'userbusiness4', // admin
      // password: 'business1234',
      showPassword: false,
      checkbox: false
    }
  },
  computed: {
    ...mapGetters({
      loading: 'loading',
      user: 'user',
      ref_code: 'ref_code',
      config_list: 'config_list',
      pmat_member: 'pmat_member',
      biz_default: 'biz_default'
    }),
    ref_code_client () {
      let refCode = {}
      if (typeof this.ref_code === 'string') {
        refCode = JSON.parse(this.ref_code)
      } else {
        refCode = this.ref_code
      }
      return refCode
    },
    redirect_register () {
      return `${process.env.VUE_APP_REDIRECT_TO_ONEID}/register`
    },
    redirect_forget_password () {
      return `${process.env.VUE_APP_REDIRECT_TO_ONEID}/type_forgot_password`
    }
  },
  mounted () {
    if (this.ref_code_client == null) {
      this.$router.push('/')
    }
  },
  methods: {
    login () {
      this.$store.commit('onLoading')
      const username = this.username
      const password = this.password

      this.$store
        .dispatch('login', {
          username,
          password
        })
        .then(() => {
          this.getConfig()
        })
        .catch((err) =>
          this.$store.commit('onAlerting', {
            message_status: err.message,
            color: '#D1392B'
          })
        )
        // .finally(() => this.$store.commit('offLoading'))
    },
    loginByClientRefCode () {
      this.$store.commit('onLoading')
      const username = this.username
      const password = this.password
      const clientRefCode = this.ref_code_client.client_ref_code

      this.$store
        .dispatch('loginByClientRefCode', {
          username,
          password,
          client_ref_code: clientRefCode
        })
        .then(() => {
          this.$store.commit('setBizID', this.biz_default[0])
          this.getConfig()
        })
        .catch((err) =>
          this.$store.commit('onAlerting', {
            message_status: err.message,
            color: '#D1392B'
          })
        )
        // .finally(() => this.$store.commit('offLoading'))
    },
    goToLoginPage () {
      this.$store.commit('logout')
      if (this.$route.name !== 'Login') {
        this.$router.push('/login')
      }
    },
    getConfig () {
      this.$store.dispatch('getConfig').then(() => {
        const config = this.config_list
        const pmatCheck = config.find((data) => { return data.name === 'PMAT_CHECK_PAYMENT_STATUS' })
        const pmatRefCode = config.find((data) => { return data.name === 'PMAT_REF_CODE' })
        if (pmatCheck.value === '1' && (pmatRefCode.value === this.ref_code_client.client_ref_code)) {
          this.$store.commit('setMember', 2)
          this.getToCheckPMATMember()
        } else {
          this.$store.commit('setMember', 1)
          this.getProfile()
        }
      })
        .catch((err) =>
          this.$store.commit('onAlerting', {
            message_status: err.message,
            color: '#D1392B'
          })
        )
    },
    getToCheckPMATMember () {
      this.$store
        .dispatch('getToCheckPMATMember')
        .then(() => {
          const pmatBiz = this.pmat_member.status_payment_business
          const config = this.config_list
          const pmatGeneralBiz = config.find((data) => { return data.name === 'PMAT_BIZ_ID_GENERAL_MEMBER' })
          const pmatAllBiz = pmatBiz.find((data) => { return data.status_payment === 'active' })
          const pmatCheckBiz = pmatBiz.find((data) => { return data.biz_id === pmatGeneralBiz.value })
          // if ((typeof pmatCheckBiz === 'object' && pmatCheckBiz.status_payment === 'active') || typeof pmatAllBiz === 'object') {
          //   this.getProfile()
          if (typeof pmatCheckBiz === 'object' || typeof pmatAllBiz === 'object') {
            this.getProfile()
          } else {
            this.$store.commit('onPMATLoginDialog')
          }
        })
        .catch(() =>
          // this.$store.commit('onAlerting', {
          //   message_status: err.message,
          //   color: '#D1392B'
          // })
          this.$store.commit('onPMATLoginDialog')
        )
    },
    getProfile () {
      this.$store
        .dispatch('getProfileData')
        .then(() => {
          const user = this.user
          const role = user.role_id
          if (role === '1') {
            this.$router.push('/dashboard')
          } else if (role === '2') {
            this.updateBusiness()
            // this.$router.push('/dashboard')
          } else {
            this.updateBusiness()
            // this.$router.push('/history_price')
            // this.goToLoginPage()
          }
        })
        .catch((err) => {
          this.$store.commit('onAlerting', {
            message_status: err.message,
            color: '#D1392B'
          })
          this.goToLoginPage()
        })
        .finally(() => this.$store.commit('offLoading'))
    },
    updateBusiness () {
      this.$store.commit('onLoadingDialog')
      this.$store.dispatch('getUpdateBusinessUser')
        .then(() => {
          const user = this.user
          const role = user.role_id
          if (role === '1') {
            this.$router.push('/dashboard')
          } else if (role === '2') {
            this.$router.push('/dashboard')
          } else {
            this.$router.push('/history_price')
          }
        })
        .catch((err) => {
          this.$store.commit('onAlerting', {
            message_status: err.message,
            color: '#D1392B'
          })
          this.goToLoginPage()
        })
        .finally(() => {
          this.$store.commit('offLoadingDialog')
          this.$store.commit('offLoading')
        })
    },
    getCode () {
      window.location.replace(
        `${process.env.VUE_APP_REDIRECT_TO_ONEID}/api/oauth/getcode?client_id=${process.env.VUE_APP_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_REDIRECT_AFTER_AUTHEN}`
      )
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
.login-page {
  height: 100%;
  font-family: Noto Sans Thai !important;
  justify-content: center;
  align-items: center;
}
.login-form {
  height: 100vh;
  font-family: Noto Sans Thai !important;
}
/* .background-login {
background-image: url("../assets/image/Background-login.png");
background-position: center center;
background-size: cover;
} */
.form {
  font-family: Noto Sans Thai !important;
  align-items: center;
  justify-content: center;
  padding: 0px 80px 70px 80px;
}
.imgTitle {
  justify-content: center;
  padding: 70px 0px 80px 50px;
}
.submitbutton.theme--dark.v-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
  color: #fafafa !important;
}
.text-button-color {
  background: linear-gradient(180deg, var(--v-default_primary-base) 0%, var(--v-default_primary_light-base) 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 26px;
  font-weight: 700 !important;
  line-height: 42px;
}
.forgotpassword {
  text-align: center;
  align-self: center;
}
.v-application .text-button-login {
  font-family: Noto Sans Thai !important;
  font-weight: 700 !important;
}
.textloginform {
  font-family: Noto Sans Thai !important;
}
</style>
